export default function(selector) {
  return function() {
    return this.matches(selector);
  };
}

export function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}




//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/matcher.js
// module id = 2
// module chunks = 0